import axios from 'axios'
import Configuration from '@/utilities/service/Configuration'

const httpClient = axios.create({
  baseURL: Configuration.value('apiHost'),
})

export default httpClient
